import {applyUrl} from "config";
import {getIdToken} from "service";

export function isAndroidApp(paramsId) {
    if (paramsId === "android") {
        return true;
    }
    return false;
}

export function shareLinkToAndroid(referralLink) {
    const referralObj = {copyReferralLink: referralLink};
    (window as any).Android.notify("REFERRAL", JSON.stringify(referralObj));
}

export function closeActivityInAndroid(status) {
    (window as any).Android.notify("BS_UPLOAD", status);
}

export function notifyAndroidAfterConsentCompletion(statusResult) {
    const dataObj = {status: statusResult};
    (window as any).Android.notify("CONSENT", JSON.stringify(dataObj));
}

export function notifyAndroidToDownloadAgreement(fileAsString) {
    const dataObj = {base64String: fileAsString};
    (window as any).Android.notify("CONSENT", JSON.stringify(dataObj));
}

export function notifyAndroidOfLoanDeclined(statusResult) {
    const dataObj = {status: statusResult};
    (window as any).Android.notify("CONSENT", JSON.stringify(dataObj));
}

export function notifyAndroidOnProceedClicked(statusResult) {
    const dataObj = {status: statusResult};
    (window as any).Android.notify("PROCEED", JSON.stringify(dataObj));
}

export function notifyDownload(fileName: string, base64: string, contentLength: number, fileType: string) {
    (window as any).Android.download(fileName, base64, contentLength, fileType);
}
export function exitWebview() {
    (window as any).Android.exit();
}
export function notifyAndroidFromWeb(url: string) {
    const obj = {url};
    (window as any).Android.notify("BROWSER_REDIRECT", JSON.stringify(obj));
}

export function notifyAndroid(arg: string, obj: object) {
    (window as any).Android.notify(arg, JSON.stringify(obj));
}

export function setAndroidLocalStorageValues(val: object) {
    const v = JSON.stringify(val);
    window.localStorage.setItem("userDetails", v);
}
export function getAndroidLocalStorageValues() {
    const v = window.localStorage.getItem("userDetails");
    return v ? JSON.parse(v) : {};
}

export function setAndroidTokenAndVersionBeforeRedirecting(apiVersion, token) {
    const userInfo = {
        id_token: token,
        apiVersion,
    };
    setAndroidLocalStorageValues(userInfo);
}

export class AndroidApiCollection {
    public apiVersion: number;
    public constructor(apiVersion: number) {
        this.apiVersion = apiVersion;
    }
    public clearWebStack() {
        (window as any).Android.notify("CLEAR_WEBVIEW_STACK", JSON.stringify({}));
    }

    public showPopUpOnBack(configValues: object) {
        if (this.apiVersion >= 179) {
            (window as any).Android.notify("BACK_POPUP_CONFIG", JSON.stringify(configValues));
        }
    }

    public toolBarConfig(configValues: object) {
        (window as any).Android.notify("TOOL_BAR_CONFIG", JSON.stringify(configValues));
    }

    public bsUploadCompletion(configValues: object) {
        (window as any).Android.notify("BANK_STATEMENT_CONFIG", JSON.stringify(configValues));
    }

    public openOkycActivity() {
        const oKycObj = {
            link: "com.datasignstech.lam.loanaminute.okyc.OKYCActivity",
            linkType: "APP_LINK",
        };
        (window as any).Android.notify("NAVIGATION_CONFIG", JSON.stringify(oKycObj));
    }

    public openRating(shouldShow: boolean, isDisbursal: boolean) {
        const ratingFlags = {"shouldShow": shouldShow, "isDisbursal": isDisbursal};
        (window as any).Android.notify("RATE_APP_CONFIG", JSON.stringify(ratingFlags));
    }

    public newOpenRating (shouldAlwaysShow: boolean, shouldShow: boolean, isDisbursal = false) {
        const ratingFlags = {shouldAlwaysShow, shouldShow: shouldShow, isDisbursal: isDisbursal};
        (window as any).Android.notify("RATE_APP_CONFIG", JSON.stringify(ratingFlags));
    };

    public notifyAndroid(arg: string, obj: object) {
        (window as any).Android.notify(arg, JSON.stringify(obj));
    }
}

export function webViewUrlInterceptor(redirectionUrl, interceptionUrl) {
    const obj = {
        linkType: "WEB_LINK",
        link: redirectionUrl,
        urlToIntercept: interceptionUrl,
        linkAuth: true,
    };
    (window as any).Android.notify("PAYMENT_ROUTE_CONFIG", JSON.stringify(obj));
}

export function webViewCamAnsStoragePermission() {
    (window as any).Android.notify("PAYMENT_PERMISSIONS_CONFIG", JSON.stringify({requestPermission : true}));
}

export function setStoreDataToLocalStorage(keyName: string, value: object) {
    sessionStorage.setItem(keyName, JSON.stringify(value));
}

export function getStoreDataFromLocalStorage(keyName: string) {
    const data = sessionStorage.getItem(keyName);
    return data ? JSON.parse(data) : null;
}

export function getRequiredDataFromAndroidToWeb(obj: object) {
    (window as any).Android.notify("ASK_REQUIRED_DATA_CONFIG", JSON.stringify(obj));
}
